module.exports = __webpack_public_path__ + "96b6d863825467281d4c9fcfabed8c01.svg";